import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getSinglePlacementStyles } from './styles';

export const SinglePlacement = ({ onRenderPlacement }) => {
  const classes = useDefaultStyles(getSinglePlacementStyles);

  return (
    <div className={classnames('single-placement', classes.singlePlacement)}>
      {onRenderPlacement()}
    </div>
  );
};

SinglePlacement.propTypes = {
  onRenderPlacement: PropTypes.func.isRequired,
};
